module.exports = __webpack_public_path__ + "img/scene-3.fd15c74.svg";